export default function AppSection() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const el = document.querySelector('#hero');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-2xl p-8 md:p-12 overflow-hidden relative">
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>

            <div className="relative flex flex-col lg:flex-row items-center gap-8">
              <div className="flex-1 text-center lg:text-left">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-4">
                  吃瓜黑料爆料 APP
                </h2>
                <p className="text-white/80 text-sm leading-relaxed mb-6 max-w-md">
                  随时随地吃最新鲜的瓜！APP端支持实时推送通知，重大爆料绝不漏看。更流畅的浏览体验，更便捷的互动功能，吃瓜从未如此简单。
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                  <a
                    href="#app"
                    onClick={handleClick}
                    className="w-full sm:w-auto px-6 py-3 bg-white text-primary-600 font-medium text-sm rounded-lg hover:bg-white/90 transition-all duration-200 whitespace-nowrap text-center cursor-pointer"
                  >
                    <i className="ri-apple-line mr-2"></i>
                    iOS 版下载
                  </a>
                  <a
                    href="#app"
                    onClick={handleClick}
                    className="w-full sm:w-auto px-6 py-3 bg-white/20 text-white font-medium text-sm rounded-lg hover:bg-white/30 border border-white/30 transition-all duration-200 whitespace-nowrap text-center cursor-pointer"
                  >
                    <i className="ri-android-line mr-2"></i>
                    Android 版下载
                  </a>
                </div>
              </div>
              <div className="flex-shrink-0">
                <div className="w-40 h-72 bg-white/15 backdrop-blur-sm rounded-2xl border border-white/20 flex items-center justify-center">
                  <div className="text-center text-white/70">
                    <i className="ri-smartphone-line text-4xl mb-2"></i>
                    <p className="text-xs">扫码下载</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}